import api from './api';
import {
  User,
  CreateUserPayload,
  UpdateUserPayload,
  EmailAvailabilityResponse,
  UserProfileResponse,
} from '@/types';

/**
 * User Service - API wrapper for UserController endpoints
 * Backend: /api/user
 */
export const userService = {
  /**
   * GET /api/user - List all users (Admin only)
   */
  getAll: () => api.get<User[]>('/user'),

  /**
   * GET /api/user/{id} - Get single user by id
   */
  getById: (id: number) => api.get<User>(`/user/${id}`),

  /**
   * POST /api/user - Create new user (Admin only)
   */
  create: (payload: CreateUserPayload) => api.post<User>('/user', payload),

  /**
   * PUT /api/user/{id} - Update existing user
   * Admin can update any user; users can update themselves
   */
  update: (id: number, payload: UpdateUserPayload) =>
    api.put<User>(`/user/${id}`, payload),

  /**
   * DELETE /api/user/{id} - Soft delete user (Admin only)
   */
  delete: (id: number) => api.delete(`/user/${id}`),

  /**
   * GET /api/user/check-email?email={email} - Check email availability
   * Returns { email, isAvailable } where isAvailable = !exists
   */
  checkEmailAvailability: (email: string) =>
    api.get<EmailAvailabilityResponse>('/user/check-email', {
      params: { email },
    }),

  /**
   * GET /api/user/current - Get current authenticated user profile
   */
  getCurrentUser: () => api.get<UserProfileResponse>('/user/current'),
};
